if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        let config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        //  config = {
        //   ...config,  // Preserve existing configurations
        //   cache: "no-store" // Prevent caching
        // };

        document.querySelector('.addLoader')?.classList.add('it_loading');
        fetch(`${routes.cart_add_url}?_=${new Date().getTime()}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);

              // let getPageURL = location.href.split("products")[1];
              
              // console.log(getPageURL) ;

              // let productURL = `/products${getPageURL}`;

              const RecentVariantKey = response.key;
              const storedVariantPrice = localStorage.getItem('recentVariantPrice');
              if (storedVariantPrice === null) {
                // No configurator data — skip localStorage overrides, keep Shopify-rendered values
              } else {
              const RecentVariantPrice = Number(storedVariantPrice);
              const RecentProductTitle= localStorage.getItem('recentProductTitle');
              const RecentProductImage= localStorage.getItem('recentProductImage');
              const RecentProductURL= localStorage.getItem('recentProductURL');

              const RecentReplacementLensImage = localStorage.getItem('recentProductReplacementLensImage');


              let imageTagElement = `
              <a href="${RecentProductURL}">
                <img class="cart-item__image" src="${RecentProductImage}" alt="" loading="eager" width="150" height="75">
              </a>
              ` ;

              let productReplacementLensImageTag = null ;
              
              if(RecentReplacementLensImage!=""){
                  productReplacementLensImageTag =   ` <a href="${RecentProductURL}">
                    <img class="cart-item__image" src="${RecentReplacementLensImage}" alt="" loading="eager" width="150" height="75">
                  </a>
                  ` ;
              }
            

              let formattedCartTotalPrice  = '';
              let CartTotalPrice = 0;
              fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                CartTotalPrice = cart.total_price/100;
                if(cart.items.find(item => item.key === RecentVariantKey)?.price === 0) { CartTotalPrice += RecentVariantPrice; }
                formattedCartTotalPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(CartTotalPrice);
              })
              .catch(error => {
                console.error('Error fetching cart data:', error);
              });
              
              setTimeout(() => {
                document.querySelector(`#CartDrawer [data-line-item-key="${RecentVariantKey}"] .cart-item__price-wrapper .price`).textContent = '$' + RecentVariantPrice.toFixed(2);
                document.querySelector(`#CartDrawer [data-line-item-key="${RecentVariantKey}"] .cart-item__details .product-option`).textContent = '$' + RecentVariantPrice.toFixed(2);
                document.querySelector(`#CartDrawer [data-line-item-key="${RecentVariantKey}"] .cart-item__name`).textContent = RecentProductTitle;
                
                document.querySelector(`#CartDrawer [data-line-item-key="${RecentVariantKey}"] .cart-item__media`).innerHTML = imageTagElement;

                if(productReplacementLensImageTag!=null){
                   document.querySelector(`#CartDrawer [data-line-item-key="${RecentVariantKey}"] .cart-item__media`).innerHTML = productReplacementLensImageTag;
                }else{
                   document.querySelector(`#CartDrawer [data-line-item-key="${RecentVariantKey}"] .cart-item__media`).innerHTML = imageTagElement;
                }
                
                document.querySelector(`#CartDrawer .totals__total-value`).textContent = formattedCartTotalPrice + ' USD';

                localStorage.removeItem("recentVariantPrice");
                localStorage.removeItem("recentProductTitle");
                localStorage.removeItem("recentProductImage");
                localStorage.removeItem("recentProductURL");
                localStorage.removeItem("recentProductReplacementLensImage");
                
                document.querySelectorAll('.customlineItemProperties .cart_item__frame_size_value').forEach(el => {
                  let frame_size_value = el.textContent.trim().split('-');
                  frame_size_value = frame_size_value[1].replace(',','');
                  // console.log("frame_size_value==",frame_size_value)
                  el.textContent = frame_size_value;
                });
                
              },1000);

              } // end storedVariantPrice !== null
            }
          })
          .catch((e) => {
            console.error(e);
            document.querySelector('.addLoader')?.classList.remove('it_loading');
          })
          .finally(() => {
            document.querySelector('.addLoader')?.classList.remove('it_loading');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
